import React, { useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthContext from '../contexts/AuthContext';
import NotificationContext from '../contexts/NotificationContext';
import logo from '../logo.jpg';
import './Header.css';

const Header = ({ toggleSidebar }) => {
    const { user, logout } = useContext(AuthContext);
    const { unreadCount, openPanel } = useContext(NotificationContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    return (
        <header className="header app-header glass d-md-none">
            <div className="header-left">
                {user && (
                    <button className="btn btn-link d-md-none text-dark p-0 me-3" onClick={toggleSidebar}>
                        <i className="bi bi-list fs-4"></i>
                    </button>
                )}
                <Link to="/" className="d-flex align-items-center gap-2 d-md-none text-decoration-none">
                    <img src={logo} alt="로고" height="32" className="rounded" />
                    {user?.company && (
                        <div className="d-flex flex-column text-start">
                            <span className="fw-bold text-dark" style={{ fontSize: '0.9rem' }}>{user.company.name}</span>
                        </div>
                    )}
                </Link>
            </div>

            <div className="header-right">
                {user ? (
                    <div className="d-flex align-items-center">
                        <button className="btn btn-light btn-sm rounded-circle btn-icon-circle me-3 position-relative" onClick={openPanel}>
                            <i className="bi bi-bell"></i>
                            {unreadCount > 0 && (
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.65rem' }}>
                                    {unreadCount > 99 ? '99+' : unreadCount}
                                    <span className="visually-hidden">unread notifications</span>
                                </span>
                            )}
                        </button>
                        <button onClick={handleLogout} className="btn btn-outline-secondary btn-sm">
                            로그아웃
                        </button>
                    </div>
                ) : (
                    /* 「회원가입」 이 옆에 있었지만 그 화면은 401 로 끝났다.
                       계정은 초대로 만든다. */
                    <Link to="/login" className="btn btn-outline-primary btn-sm">로그인</Link>
                )}
            </div>
        </header>
    );
};

export default Header;
